import { slugs } from '@/constants/slugs'

export type ManualUpcomingCollectionContent = {
  guid: string
  slug: string
  projectSlug: string
  name: string
  subtitle?: string | null
  description?: string | null
  posterLandscapeCloudinaryPath?: string | null
  duration?: number | null
  episodeNumber?: number | null
  publiclyAvailableDate?: string | null
  earlyAccessDate?: string | null
  guildAvailableDate?: string | null
  releaseDate?: string | null
  type: 'EPISODE' | 'MOVIE'
}

export const WATCH_COLLECTION_UPCOMING_CONTENT: Record<string, ManualUpcomingCollectionContent[]> = {
  [slugs.homesteadSeries]: [
    {
      guid: '10a7c19c-c0e8-4b75-9d2b-c8e9824fe265',
      slug: 'homestead-s01-e03',
      projectSlug: slugs.homesteadSeries,
      name: 'Episode 3 ',
      posterLandscapeCloudinaryPath: 'v1734400081/studio-app/catalog/830a48f4-df4e-4891-848d-83869a5e17c1',
      episodeNumber: 3,
      publiclyAvailableDate: null,
      earlyAccessDate: '2025-11-27T00:00:00Z',
      guildAvailableDate: '2025-11-27T00:00:00Z',
      releaseDate: '2025-11-22T04:09:36Z',
      type: 'EPISODE',
    },
    {
      guid: 'bd582d9d-ca76-489c-a0fb-c4024787866a',
      slug: 'homestead-s01-e04',
      projectSlug: slugs.homesteadSeries,
      name: 'Episode 4',
      posterLandscapeCloudinaryPath: 'v1763589655/studio-app/catalog/512f7c6c-0f4a-4174-9684-d511abe6b2e4',
      episodeNumber: 4,
      publiclyAvailableDate: null,
      earlyAccessDate: '2025-12-04T00:00:00Z',
      guildAvailableDate: '2025-12-04T00:00:00Z',
      releaseDate: '2025-11-22T04:09:36Z',
      type: 'EPISODE',
    },
    {
      guid: '51ae18b1-c438-412d-9269-3a0ed2ef9791',
      slug: 'homestead-s01-e05',
      projectSlug: slugs.homesteadSeries,
      name: 'Episode 5',
      posterLandscapeCloudinaryPath: 'v1763589655/studio-app/catalog/512f7c6c-0f4a-4174-9684-d511abe6b2e4',
      episodeNumber: 5,
      publiclyAvailableDate: null,
      earlyAccessDate: '2025-12-11T00:00:00Z',
      guildAvailableDate: '2025-12-11T00:00:00Z',
      releaseDate: '2025-11-22T04:09:36Z',
      type: 'EPISODE',
    },
    {
      guid: 'badee21f-e927-4102-89b5-8bdc87feee6b',
      slug: 'homestead-s01-e06',
      projectSlug: slugs.homesteadSeries,
      name: 'Episode 6',
      posterLandscapeCloudinaryPath: 'v1763589655/studio-app/catalog/512f7c6c-0f4a-4174-9684-d511abe6b2e4',
      episodeNumber: 6,
      publiclyAvailableDate: null,
      earlyAccessDate: '2025-12-18T00:00:00Z',
      guildAvailableDate: '2025-12-18T00:00:00Z',
      releaseDate: '2025-11-22T04:09:36Z',
      type: 'EPISODE',
    },
    {
      guid: 'bff21208-5a2e-46f9-8c42-8f99228a6d97',
      slug: 'homestead-s01-e07',
      projectSlug: slugs.homesteadSeries,
      name: 'Episode 7',
      posterLandscapeCloudinaryPath: 'v1763589655/studio-app/catalog/512f7c6c-0f4a-4174-9684-d511abe6b2e4',
      episodeNumber: 7,
      publiclyAvailableDate: null,
      earlyAccessDate: '2025-12-25T00:00:00Z',
      guildAvailableDate: '2025-12-25T00:00:00Z',
      releaseDate: '2025-11-22T04:09:36Z',
      type: 'EPISODE',
    },
    {
      guid: '94be1832-615b-494e-8248-b40916477dfa',
      slug: 'homestead-s01-e08',
      projectSlug: slugs.homesteadSeries,
      name: 'Episode 8',
      posterLandscapeCloudinaryPath: 'v1763589655/studio-app/catalog/512f7c6c-0f4a-4174-9684-d511abe6b2e4',
      episodeNumber: 8,
      publiclyAvailableDate: null,
      earlyAccessDate: '2025-12-26T00:00:00Z',
      guildAvailableDate: '2025-12-26T00:00:00Z',
      releaseDate: '2025-11-22T04:09:36Z',
      type: 'EPISODE',
    },
  ],
}
